import { render, staticRenderFns } from "./deliveryData.vue?vue&type=template&id=31ac2bd9&scoped=true"
import script from "./deliveryData.vue?vue&type=script&lang=js"
export * from "./deliveryData.vue?vue&type=script&lang=js"
import style0 from "./deliveryData.vue?vue&type=style&index=0&id=31ac2bd9&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ac2bd9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\space\\tops\\tops-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31ac2bd9')) {
      api.createRecord('31ac2bd9', component.options)
    } else {
      api.reload('31ac2bd9', component.options)
    }
    module.hot.accept("./deliveryData.vue?vue&type=template&id=31ac2bd9&scoped=true", function () {
      api.rerender('31ac2bd9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/data/deliveryData.vue"
export default component.exports